import AppGradientText, {
  type IGradientTextProps,
} from "@core-components/text/GradientText";

const ValorantGradientText: React.FC<IGradientTextProps> = ({
  children,
  className,
  ...rest
}) => {
  return (
    <AppGradientText
      className={`text-gradient-red-purple ${className}`}
      {...rest}
    >
      {children}
    </AppGradientText>
  );
};

export default ValorantGradientText;
